'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _dressChecks = require('ifeis-isomorphic/lib/redux/actions/dress-checks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DressCheckReportController = function () {
  function DressCheckReportController(feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService) {
    var _this = this;

    _classCallCheck(this, DressCheckReportController);

    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.feis = feis;
    this.headers = ['Dancer Number', 'Dancer Name', 'Account Owner', 'Account Email', 'Comp #', 'Comp Description', 'School', 'Teacher(s) Name', 'Teacher(s) Email', 'Comment'];
    this.reportData = [];

    $ngRedux.dispatch((0, _dressChecks.getDressChecksReport)(feis.id)).then(function (data) {
      _this.reportData = data.payload;
    });
  }

  _createClass(DressCheckReportController, [{
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {

      var csv = [];
      csv.push(this.headers);
      this.reportData.forEach(function (r) {
        csv.push([r.dancerNum, r.dancerName, r.accountOwner, r.accountEmail, r.compId, r.compDescription, r.school, r.teacherName, r.teacherEmail, !r.comment ? '' : r.comment]);
        csv.push(['']);
      });
      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Dress_Report.csv');
    }
  }]);

  return DressCheckReportController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.dress-report', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.dress-report', {
    url: '/dress-report',
    template: require('./tpl.html'),
    controller: DressCheckReportController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/dress-report/index.js
// module id = 562
// module chunks = 0